import TimeDisplay from 'app/ui/display/TimeDisplay';
import ScoreDisplay from 'app/ui/display/ScoreDisplay';

export default class HudGamePlay extends Phaser.Group {
  constructor({ game, levelData }) {
    super(game);
    this.fixedToCamera = true;

    this.backing = this.game.make.graphics();
    this.backing.beginFill(0x000000, 1);
    this.backing.drawRect(0, 0, this.game.defaultWidth, 85);
    this.add(this.backing);

    this.timeDisplay = new TimeDisplay({ game });
    this.timeDisplay.scale.set(50 / this.timeDisplay.height);
    this.timeDisplay.x = this.game.width * 0.5 - this.timeDisplay.width * this.timeDisplay.scale.x - 25;
    this.timeDisplay.y = 20;
    this.add(this.timeDisplay);

    this.scoreDisplay = new ScoreDisplay({ game, target: levelData.collectTarget });
    this.scoreDisplay.x = this.game.width * 0.5 + 25;
    this.scoreDisplay.y = 20;
    this.scoreDisplay.scale.set(60 / this.scoreDisplay.height);
    this.add(this.scoreDisplay);
  }

  updateStats(time, score) {
    this.timeDisplay.setTime(time);
    this.scoreDisplay.setScore(score);
  }
}
